module.exports = __webpack_public_path__ + "img/ic-angel.2c061999.svg";